<app-performance>
    <app-data-grid-comp
        [gridId]="gridId"
        [tableId]="db_tables.Reviews"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [category]="translate.instant('Reviews')"
        [rowSelectionSettings]="{
            canSelectRows: false,
            selectableMode: 'none',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        searchable="true"
        hideActionButtons="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        export="customExcel"
        (emitExportEvent)="allData()"
        (emitOpenDialogEvent)="getReview($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
    ></app-data-grid-comp>

    <kendo-excelexport
        [data]="excelData"
        [fileName]="fileName"
        #excelexport
    >
        <kendo-excelexport-column
            *ngFor="let column of excelColumns"
            [field]="column.field"
            [title]="column.title"
        >
        </kendo-excelexport-column>
    </kendo-excelexport>
</app-performance>
